<!-- 使用到的租户 还呗、58 -->
<template>
  <div
    class="header"
    :style="{ backgroundImage: `url(${item.display_img_url})` }"
  >
    <div class="header-content">
      <div class="header-time" v-if="!isMember && namespaceGroup === 'huanbei'">
        购买后60天有效
      </div>
      <div class="header-time" v-else-if="showExpiryDate">
        到期时间：{{ cardExpiryDate }}
      </div>
      <div class="save-money" v-else-if="showSaveMoney">
        <div class="unit">¥</div>
        <div class="price">{{ savePrice }}</div>
        <div class="text">最高立省</div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";
import Dayjs from "dayjs";

import { useStore, useRoute } from "@/components/use/base";

export default defineComponent({
  props: ["item", "card", "packageInfo"],
  setup(props) {
    const store = useStore();
    const route = useRoute();

    const showExpiryDate = computed(() => {
      return isMember.value && route.name !== "visitor";
    });

    const cardExpiryDate = computed(() =>
      Dayjs(store.state.userInfo?.card_expiry_date?.[0]).format("YYYY.MM.DD")
    );
    const namespaceGroup = computed(
      () => store.state.namespaceInfo.namespace_group_en
    );

    const showSaveMoney = computed(
      () => route.name === "visitor" && namespaceGroup.value !== "huanbei"
    );

    const savePrice = computed(() => {
      return Math.round(
        (props.packageInfo?.face_value || 0) + Number.EPSILON
      ).toFixed(2);
    });

    const isMember = computed(() => store.state.isMember);

    return {
      isMember,
      cardExpiryDate,
      namespaceGroup,
      savePrice,
      showExpiryDate,
      showSaveMoney,
    };
  },
});
</script>

<style lang="less" scoped>
.header {
  height: 168px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  margin-bottom: -12px;

  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    left: 49px;
    right: 59px;
    top: 108px;

    .use-time {
      font-weight: 400;
      font-size: 12px;
      color: #b8aba4;
      line-height: 17px;
      margin-top: 10px;
    }

    .header-time {
      font-weight: 400;
      font-size: 12px;
      color: #c3b6ae;
      line-height: 17px;
    }

    .save-money {
      display: flex;
      align-items: center;
      justify-content: center;
      .unit {
        font-weight: 500;
        font-size: 12px;
        color: #c3b6ae;
        line-height: 12px;
        margin-right: 2px;
        margin-top: 6px;
      }
      .price {
        font-weight: 500;
        font-size: 20px;
        color: #c3b6ae;
        line-height: 20px;
        margin-right: 5px;
      }
      .text {
        font-weight: 400;
        font-size: 12px;
        color: #b8aba4;
        line-height: 12px;
        margin-top: 1px;
      }
    }
  }
}
</style>
